import { createFileRoute } from '@tanstack/react-router';
import { ExploreLandingPage } from '@/features/metric-hub/explore/ExploreLandingPage';

export const Route = createFileRoute('/_authed/metric-hub/explore/')({
  component: ExploreLandingPage,
});
